import { connect } from 'react-redux';
import {
  getDataForDonorDetails,
  getDataForDonorSettings,
  toggleDonorDetailsModal,
  toggleDonorSettingsModal,
} from '../../redux/users/actions';
import TimeSlot from "./TimeSlot";
import { setCurrentAppointment } from '../../redux/timeslots/actions';

const mapDispatchToProps = {
  getDataForDonorDetails,
  getDataForDonorSettings,
  toggleDonorDetailsModal,
  toggleDonorSettingsModal,
  setCurrentAppointment
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSlot);